import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useMarketplacePartnerRegisterPageContext } from '../../marketplacePartnerRegisterPageContext'
import { MarketplacePartnerRegisterPageFormInputField } from '../MarketplacePartnerRegisterPageFormInputField'

export const MarketplacePartnerRegisterPageFormBasicInformationsContactDetails: FC =
  () => {
    const { formState } = useMarketplacePartnerRegisterPageContext()
    formState.use()

    return (
      <div className="flex flex-col gap-4">
        <div className="text-l">
          <FormattedMessage id="marketplacePartnerRegisterPage.basicInformations.contactDetails.title" />
        </div>

        <MarketplacePartnerRegisterPageFormInputField
          fieldName="firstName"
          label={<FormattedMessage id="general.label.firstName" />}
          required
        />

        <MarketplacePartnerRegisterPageFormInputField
          fieldName="lastName"
          label={<FormattedMessage id="general.label.surname" />}
          required
        />
        <MarketplacePartnerRegisterPageFormInputField
          fieldName="email"
          label={<FormattedMessage id="general.label.email" />}
          required
        />
        <MarketplacePartnerRegisterPageFormInputField
          fieldName="phoneNumber"
          label={<FormattedMessage id="general.label.phoneNumber" />}
          required
          type="tel"
        />
      </div>
    )
  }
